import { useMemo } from 'react';
import { useWindowDimensions } from 'react-native';

import { responsiveInfoFor, type ResponsiveInfo } from './breakpoints';

export { BREAKPOINTS, breakpointForWidth, responsiveInfoFor } from './breakpoints';
export type { Breakpoint, ResponsiveInfo } from './breakpoints';

/**
 * The only responsive hook in the app. Breakpoints (phone <760, tablet
 * 760–1179, desktop 1180–1439, wide >=1440) live in ./breakpoints.
 */
export function useResponsive(): ResponsiveInfo {
  const { width, height } = useWindowDimensions();

  return useMemo(() => responsiveInfoFor(width, height), [height, width]);
}
